import { render, staticRenderFns } from "./MasseuseType.vue?vue&type=template&id=4fc227c1&scoped=true&"
import script from "./MasseuseType.vue?vue&type=script&lang=js&"
export * from "./MasseuseType.vue?vue&type=script&lang=js&"
import style0 from "./MasseuseType.vue?vue&type=style&index=0&id=4fc227c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc227c1",
  null
  
)

export default component.exports